// extracted by mini-css-extract-plugin
export default {"error_page_content":"src-common-PageNotFound-style__error_page_content--c4pJ_"};